import { clientConfig } from '@/config/client';

const { channelsPaywall } = clientConfig;

export const getChannelsPaywallImageUrl = (
    desktopBackgroundUrl: string | undefined,
    dir: 'rtl' | 'ltr'
) => {
    if (desktopBackgroundUrl) return desktopBackgroundUrl;

    return dir === 'rtl' ? channelsPaywall.rtlCoverUrl : channelsPaywall.coverUrl;
};
